import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=15565764&lang=less&scoped=true"
script.__scopeId = "data-v-15565764"

export default script